/*
* PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
* Copyright (c) 2017 Pearson Education, Inc.
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains the property of
* Pearson Education, Inc. The intellectual and technical concepts contained
* herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
* and Foreign Patents, patent applications, and are protected by trade secret
* or copyright law. Dissemination of this information, reproduction of this
* material, and copying or distribution of this software is strictly forbidden
* unless prior written permission is obtained from Pearson Education, Inc.
*/

import { string, objectOf } from 'prop-types'
import React from 'react'
import Icon from '../Icon'

const AlertContent = ({ icon, title, description, locale }) => {
  return (
    <div className='alert-content-container'>
      <Icon fileName={icon.name} name='alert' title={icon.label} />
      <div className='alert-content'>
        <h2 className='pe-label alert-title'>
          <strong>
            {title}
          </strong>
        </h2>
        <p className='pe-paragraph alert-text'>{description}</p>
      </div>
    </div>
  )
}

AlertContent.propTypes = {
  icon: objectOf(string, string),
  description: string,
  locale: string
}

AlertContent.defaultProps = {
  description: '',
  locale: 'en'
}

export default AlertContent
